/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponProductVariantSummary {
  activeFeedbackId?: number;
  brandEquity?: number;
  brandId?: number;
  brandLogoImage?: string;
  brandName?: string;
  brandSummary?: string;
  costPrice?: number;
  couponId?: number;
  couponProductVariantType?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  defaultProductVariantId?: number;
  descriptionArticleId?: number;
  displayOrder?: number;
  externalId?: number;
  externalStoreUrl?: string;
  groupVariant?: number;
  id?: number;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  isSellable?: boolean;
  isTradeable?: boolean;
  maxTradesPerPerson?: number;
  ncm?: string;
  orderCount?: number;
  productId?: number;
  productName?: string;
  productSummary?: string;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  ratingAverage?: number;
  reviewCount?: number;
  salePrice?: number;
  saleStock?: number;
  showOnWebSite?: boolean;
  stockCount?: number;
  tradeActive?: boolean;
  tradeCount?: number;
  tradePoints?: number;
  tradeStock?: number;
  typeName?: string;
  variantSummary?: string;
  weight?: number;
}
